module.exports = __webpack_public_path__ + "img/glowEss1.17992290.jpg";